import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { Root } from '@/api/helpers/get-current-user'

export const mockGetUserInfo = http.get(
  '/my-business/api/agency/v1/users',
  () => {
    const response: Root = {
      timestamp: faker.date.recent().toISOString(),
      data: Array.from({ length: 3 }).map(() => ({
        active: faker.datatype.boolean({ probability: 1 }),
        addressData: {
          address: faker.location.streetAddress(),
          complement: faker.lorem.words(2),
          number: faker.string.numeric(4),
          city: faker.location.city(),
          state: faker.location.state(),
          zipcode: faker.location.zipCode(),
        },
        companyChainProfileData: {
          companyChainClassification: faker.helpers.arrayElement([
            'BASIC',
            'SMART',
          ]),
          companyChainProfileStatusEnum: 'RELEASED',
          companyChainType: faker.helpers.arrayElement(['AGENCY', 'OPERATOR']),
        },
        alphaId: faker.string.uuid(),
        companyTypeCode: faker.helpers.arrayElement(['AGENCY_CHAIN', 'AGENCY']),
        contactData: {
          companyEmail: faker.internet.email(),
          name: faker.person.fullName(),
          companyPhone: faker.phone.number(),
        },
        legalData: {
          corporateName: faker.company.name(),
          municipalRegistration: faker.string.numeric(10),
          stateRegistration: faker.string.numeric(10),
          name: faker.company.name(),
          observation: faker.lorem.sentence(),
          taxpayerId: faker.string.numeric(14),
        },
        responsibleData: {
          name: faker.person.fullName(),
          companyPosition: faker.person.jobTitle(),
          responsibleTaxpayerId: faker.string.numeric(11),
        },
        contracts: {
          b2bContract: faker.internet.url(),
          socialContract: faker.internet.url(),
        },
      })),
    }

    return HttpResponse.json(response, { status: 200 })
  },
)
